
// IMPORTANT: Changes here must match to changes in Authorization/EntitlementNames.cs

const Entitlements = {
  ImportDataModule: {
    AddNewEnum: "Add New Enum",
    ViewImportList: "View Import List",
    ViewMapsManager: "View Maps Manager",
    ViewInternalFields: "View Internal Fields",
    EditInternalFields: "Edit Internal Fields",
    EditInternalFieldDescription: "Edit Internal Field Description",
    EditMapping: "Edit Mapping",
    DeleteMapping: "Delete Mapping",
    ViewApiImports: "View API Imports",
    ViewImportTypes: "View Import Types",
    ViewGroups: "View Groups",

    ImportSellerData: "Import Seller Data",
    ImportDiligenceData: "Import Diligence Data",
    ImportExceptionData: "Import Exception Data",
    ImportTransactionData: "Import Transaction Data",
    ImportInternalData : "Import Internal/Override Data",
    ImportInternalProtectedData : "Import Internal/Override Data into Protected Fields",
    ImportServicingData: "Import Servicing Data",
    ImportPriceData: "Import Price Data",
    ImportCashflowData: "Import Cash Flow Data",
    ServicingTransfers: "Servicing Transfers",
    ImportCommentData: "Import Comment Data"
  },
  TransactionManagementModule: {
    ViewBulkAcquisition : "View Bulk Acquisition",
    ReverseMarkAsBid : "Reverse Mark as Bid",
    ChangeStatusWon : "Change Status to Won",
    ReverseMarkAsWon : "Reverse Mark as Won",
    ChangeStatusPendingSettle : "Change Status to Pending Settle",
    ReverseMarkAsPendingSettle : "Reserve Mark Pending Settle",
    ChangeStatusFunded : "Change Status to Funded",
    ReverseMarkAsFunded : "Reverse Mark as Funded",
    ChangeStatusPassed : "Change Status to Passed",
    ReverseMarkAsPassed : "Reverse Mark as Passed",
    ChangeStatusLost : "Change Status to Lost",
    ReverseMarkAsLost: "Reverse Mark as Lost",
    ChangeStatusIndication: "Change Status to Indication",
    ReverseMarkAsIndication : "Reverse Mark to Indication",
    AddBulkAcquisitionPackage : "Add Bulk Acquisition Package",
    ViewRateLockPackage : "View Rate Lock Package",
    ViewAdvisoryPackage : "View Advisory Package",
    AddAdvisoryPackage : "Add Advisory Package",
    DeleteBulkAcquisitionPackage : "Delete Bulk Acquisition Package",
    DeleteRateLockPackage : "Delete RateLock Package",
    DeleteAdvisoryPackage : "Delete Advisory Package",
    ViewAllTransactionTabs : "View All Transaction tabs",
    EditTransactionInfoDetailsBid : "Edit Transaction Info Details while in Bid",
    EditTransactionInfoDetailsWon : "Edit Transaction Info Details while in Won",
    EditTransactionInfoDetailsPendingSettle : "Edit Transaction Info Details while in Pending Settle",
    EditTransactionInfoDetailsPassed : "Edit Transaction Info Details while in Passed",
    EditTransactionInfoDetailsLost : "Edit Transaction Info Details while in Lost",
    EditTransactionInfoDetailsIndication: "Edit Transaction Info Details while in Indication",
    ChangePackageBuyer : "Change Package Buyer",
    ViewExitDeals: "View Exit Deals",
    CreateEditExitDeal: "Edit Exit Deal",
    AwardHoldDeal: "Award Deal in Hold",
    AwardSourcedDeal: "Award Sourced Deal",
    CancelAwardedDeal: "Cancel Awarded Deal",
    CancelHoldDeal: "Cancel Deal in Hold",
    CancelPendingSettleDeal: "Cancel Pending Settle Deal",
    CancelSourcedDeal: "Cancel Sourced Deal",
    HoldSourcedDeal: 'Hold Sourced Deal',
    MarkDealAsPendingSettle: "Mark Deal as Pending Settle",
    MarkDealAsSold: "Mark Deal as Sold",
    ReverseAwardedDealToSourced: "Reverse Awarded Deal to Sourced",
    ReversePendingSettleDealToAwarded: "Reverse Pending Settle Deal to Awarded",
    ReverseSettledDealToPendingSettle: "Reverse Settled Deal to Pending Settle",
    ReverseHoldDeal: "Reverse Hold Deal",
    ReverseCancelledDeal: "Reverse Cancelled Deal",
    EditMLPAInfo : "Edit MLPA Info",
    ViewLoans: "View Loans",
    KickOffLoans : "Kick Off Loans",
    RestoreLoans : "Restore Loans",
    MoveLoans : "Move Loans",
    SplitLoans : "Split Loans",
    MergeBulkAcquisitionPackage: "Merge Package",
    MoveDealLoans: "Move Exit Deal Loans",
    RemoveLoansFromDeal: "Remove Loans from Exit Deal",
    AllocateLoansToDeal: "Allocate Loans to Exit Deal",
    LiquidateLoans: "Liquidate Loans",
    ReinstateLoans: "Reinstate Loans",
    ViewSalespersonMaintenance: "View Salesperson Maintenance",
    CreateEditSalespersonMaintenance: "Edit Salesperson Maintenance",
    MergeExitDeal: "Merge Exit Deal",
    RunPricing: "Run Pricing",
    CreateTradingAccounts: "Create Trading Accounts",
    CreateCusips: "Create CUSIPs",
    AssignReassignTradingAccounts: "Assign/Reassign Trading Accounts",
    AssignReassignCusips: "Assign/Reassign CUSIPs",
    BypassMLPAFundingRequirement: "Bypass MLPA Funding Requirement"
  },
  InventoryManagementModule: {
    ViewInventoryBrowser: "View Inventory Browser",
    ViewLoanDetails:"View Loan Details"
  },
  VendorsContactsModule: {
    ViewCounterparties: "View Counterparties",
    EdiCounterparties: "Edit Counterparties",
    UpdateClientEntityFlag: "Update Client Entity Flag"
  },
  ReviewOrderModule: {
    ViewReviewOrder: "View Review Order",
    ExportReviewOrder: "Export Review Order",
    AddReviewOrder: "Add Review Order",
    UpdateReviewOrder: "Update Review Order"
  },
  RemittanceCashFlowGoldenPromotionModule: {
    DirectRemittanceImport: "Direct Remittance Import",
    ApproveRemittance: "Approve Remittance",
    UnilaterallyApproveRemittance: "Unilaterally Approve Remittance"
  },
  ReportEntityManagementModule: {
    SaveOrDeleteCalculatedFields: "Save/Delete Calculated Fields",
    SaveOrDeleteCarves: "Save/Delete Carves",
    SaveOrDeleteFilters: "Save/Delete Filters",
    SaveOrDeleteLookups: "Save/Delete Lookups",
    SaveOrDeleteReports: "Save/Delete Reports",
    SaveOrDeleteStrats: "Save/Delete Strats",
    SaveOrDeleteValidations: "Save/Delete Validations",
    SaveOrDeleteListViews: "Save/Delete List Views"
  },
  TaskManagementModule: {
    CreateTaskTemplates: "Create Task Templates",
    EditOrRemoveTaskTemplates: "Edit/Remove Task Templates"
  },
  LimitSetsModule: {
    CreateLimitSets: "Create Limit Sets",
    EditLimitSets: "Edit Limit Sets",
    DeleteLimitSets: "Delete Limit Sets"
  },
};

export default Entitlements;